import {
    GET_LOCATION_LIST_PROGRESS, GET_LOCATION_LIST_SUCCESS, GET_LOCATION_LIST_FAILURE,
    ADD_LOCATION_PROGRESS, ADD_LOCATION_SUCCESS, ADD_LOCATION_FAILURE,
    EDIT_DELETE_LOCATION_PROGRESS, EDIT_DELETE_LOCATION_SUCCESS, EDIT_DELETE_LOCATION_FAILURE,

    RESET_MESSAGE,

} from '../../types/actionTypes';

const initialState = {
    location: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const location_reducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_LOCATION_LIST_SUCCESS:
            return { ...state, location: action.location, loading: false };
        case GET_LOCATION_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_LOCATION_LIST_PROGRESS:
            return { ...state, loading: true, error: false };

        case ADD_LOCATION_PROGRESS:
            return { ...state, loading: true };
        case ADD_LOCATION_SUCCESS:
            return { ...state, location: [...state.location, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_LOCATION_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case EDIT_DELETE_LOCATION_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_LOCATION_SUCCESS:
            return {
                ...state,
                location: state.location.map((location) =>
                    location.id === action.payload.id ? action.payload : location
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_LOCATION_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case RESET_MESSAGE:
            return { ...state, message: null };

        default:
            return state
    }
}

export default location_reducer;